import { render, staticRenderFns } from "./CourseContentMenu.vue?vue&type=template&id=b557f02a"
import script from "./CourseContentMenu.vue?vue&type=script&lang=js"
export * from "./CourseContentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports